import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const LastPage = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 22 20">
      <path d="M20.605,0.04c-0.403,0 -0.73,0.32 -0.745,0.719l0,18.484c0,0.412 0.333,0.747 0.745,0.747c0.402,0 0.73,-0.32 0.744,-0.72l0,-18.482c0,-0.413 -0.333,-0.747 -0.744,-0.747l0,-0.001Zm-17.157,0.319c-1.04,-0.671 -2.425,-0.374 -3.093,0.665c-0.194,0.301 -0.312,0.644 -0.345,1l-0.01,0.214l0.033,15.45c0.002,1.236 1.007,2.24 2.243,2.24c0.33,0 0.656,-0.073 0.952,-0.213l0.217,-0.117l12.258,-7.52c1.052,-0.645 1.38,-2.023 0.731,-3.077c-0.14,-0.229 -0.32,-0.43 -0.531,-0.595l-0.164,-0.116l-12.29,-7.931l-0.001,0Zm-1.822,1.452c0.203,-0.291 0.58,-0.395 0.899,-0.26l0.117,0.061l12.29,7.931c0.094,0.061 0.173,0.142 0.232,0.237c0.192,0.313 0.127,0.71 -0.136,0.946l-0.108,0.08l-12.257,7.52c-0.118,0.072 -0.252,0.11 -0.39,0.11c-0.371,0 -0.68,-0.271 -0.738,-0.626l-0.01,-0.121l-0.033,-15.45c0,-0.108 0.023,-0.214 0.067,-0.311l0.051,-0.094l0.016,-0.023Z" />
    </svg>
  );
};

LastPage.defaultProps = {
  width: '100%',
  height: '100%',
};

export default LastPage;
